import axios from 'axios'
const user = {
  'first_name': '',
  'last_name': '',
  'name_verified': false,
  'email': '',
  'email_verified': false,
  'email_otp_generated': false,
  'phone': '',
  'phone_verified': false,
  'phone_otp_generated': false,
  'phone_object': {},
  'country': 233,
  'state': '',
  'address_line1': '',
  'address_line2': '',
  'city': '',
  'postal_code': '',
  'email_otp_id': '',
  'phone_otp_id': '',
  'address_verified': false,
  'profile_image': '',
  'image_id': null,
  'country_name': '',
  'state_name': '',
  'welcome': false,
  'location_service_used': false,
  'existing_user': false,
  'store_verified': false,
  'store_details': {
    name: '',
    storeId: ''
  }
}
const state = {
  user
}

const actions = {
  checkEmailExists ({ commit, state }, email) {
    return axios({
      url: process.env.API_URL + '/ws/userservice/request/course/' + process.env.GAME_ID + '/email/' + email,
      method: 'GET'
    })
  },
  async sendOtp ({ commit, state, dispatch }, email) {
    const isEmailExists = await dispatch('checkEmailExists', email)
    // console.log(isEmailExists.data.userState)
    if (isEmailExists.data.userState === 0) { // new user
      return axios({
        url: process.env.API_URL + '/ws/userservice/request/otp/email/' + email,
        method: 'GET'
      })
    } else {
      return isEmailExists.data
    }
  },
  async sendOtpOnPhone ({ commit, state, dispatch }, phone) {
    return axios({
      url: process.env.API_URL + '/ws/userservice/v2/otp-sms/phone/' + phone,
      method: 'GET'
    })
  }
}
const getters = {
  getUserDetails (state) {
    return state.user
  }
}
const mutations = {
  setUser (state, detail) {
    state.user = detail
  },
  resetUser (state) {
    state.user = user
  }
}
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/registration.js